// Deprecated. Please refrain from new usage
import PropTypes from "prop-types";
import React from "react";

import { Grid } from "@material-ui/core";

const CustomHeader = (props) => {
  const derivedStyle = { height: 100, overflow: "hidden", ...props.style };
  return (
    <div
      style={{
        margin: 0,
        padding: 20,
      }}
    >
      <Grid container spacing={5} style={derivedStyle}>
        {props.children}
      </Grid>
    </div>
  );
};

CustomHeader.propTypes = {
  style: PropTypes.object,
  children: PropTypes.node.isRequired,
};

CustomHeader.defaultProps = {
  style: {
    color: "white",
  },
};

export default CustomHeader;
